import Chat from '@chat/src/chat';
import eventBus from '../../eventbus';
import CodeBlock from './CodeBlock.vue';

export function getFmtDate(time){
	let fulldate = false;

	if (time != undefined){
		let nd = new Date(time);
		let cd = new Date(Date.now());
		fulldate = cd.getDate() != nd.getDate() || cd.getMonth() != nd.getMonth();
	}

	if (fulldate){
		return Date.format('%d.%m.%y %H:%M:%S', time);
	} else {
		return Date.format('%H:%M:%S', time);
	}
}

export const MessageBody = {
	props: {
		processedBody: Array,
		inline: Boolean,
	},

	render(h) {
		return h(this.inline ? 'span' : 'div', {}, this.renderObjs(h, this.processedBody));
	},

	methods: {
		renderObjs(h, objs) {
			let res = [];

			for (let obj of objs) {
				switch (obj.type) {
					case 'raw':
						res.push(
							<span domPropsInnerHTML={obj.html}/>
						);
						break;

					case 'text':
						res.push(obj.text);
						break;

					case 'url':
						res.push(
							<a href={obj.url} target="_blank" rel="noopener">{obj.url}</a>
						);
						break;

					case 'room':
						res.push(
							<a href="#"
								title="Подключиться к комнате"
								onClick={e => this.joinRoomClick(e, obj.room)}>{obj.room}</a>
						);
						break;

					case 'smile':
						res.push(
							<img src={`/assets/i/smilies/${obj.icon}`} alt={obj.icon} title={obj.code}/>
						);
						break;

					case 'mention':
						if (obj.user.user_id > 0) {
							res.push(
								<a href={`//sinair.net/profile/${obj.user.user_id}`}
									target="_blank"
									style={{color: obj.user.color}}>@{obj.user.name}</a>
							);
						} else {
							res.push(
								<span style={{color: obj.user.color}}>@{obj.user.name}</span>
							);
						}
						break;

					case 'quote':
						res.push(
							<span class="quote">{this.renderObjs(h, obj.processedBody)}</span>
						);
						break;

					case 'command':
						res.push(
							<span style={{color: Chat.syscolor2}}>{obj.text}</span>
						);
						break;

					case 'code':
						res.push(
							<span class="code">{obj.text}</span>
						);
						break;

					case 'codeblock':
						res.push(
							<CodeBlock data={obj}/>
						);
						break;
				}
			}

			return res;
		},

		joinRoomClick(e, room) {
			e.preventDefault();
			eventBus.$emit('joinRoom', room);
			return false;
		},
	},
};

export const MessageBase = {
	components: {
		MessageBody,
	},

	props: {
		/*{
			type: 'message',
			continuous,
			time: dt.time*1000,
			from: {
				id: dt.from,
				nick: dt.from_login,
				color: dt.color,
			},
			body: dt.message,
			processedBody: MessagePreprocessor.preprocessMessageText(this.body),
		}*/
		message: Object,
	},

	computed: {
		body(){
			return this.message.processedBody;
		},

		sysbody(){
			return this.body;
		},

		isSystem(){
			return this.message.type == 'sysmessage' || this.message.type.substr(0, 7) == 'status_';
		},

		syscolor2(){
			return Chat.syscolor2;
		},
	},

	methods: {
		date(dt){
			return getFmtDate(dt);
		},

		quoteMouseDownHandler(e) {
			e.preventDefault();
		},

		pasteReply() {
			let q = `> ${getFmtDate(this.message.time)} `;

			if (this.message.type.substr(0, 7) == 'message'){
				q += `@${this.message.from.nick}: `;
			}

			let selection = document.getSelection().toString();

			let body = selection
				|| this.message.body
				|| (this.$el.querySelector('.chat-msg-body') || {}).innerText
				|| '<пусто>';

			q += body.replace(/\n/g, '\n> ');
			q += '\n\n';

			this.$emit('pasteText', q);
		},

		pasteAuthorMention() {
			this.$emit('pasteText', `@${this.message.from.nick} `);
		},

		pasteReceiverMention() {
			this.$emit('pasteText', `@${this.message.to.nick} `);
		},
	},
};
